// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CAR_DATA_MASTER_UPDATE_BRAND_LIST,
} from './constants';

export function updateBrandList(text) {
  return {
    type: CAR_DATA_MASTER_UPDATE_BRAND_LIST,
    text: text
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_UPDATE_BRAND_LIST:
      let aux = [...state.brandListOrigin];
      aux = aux.filter(brand => brand.code.toLowerCase().includes(action.text.toLowerCase()) || brand.name.toLowerCase().includes(action.text.toLowerCase()));
      return {
        ...state,
        brandList: [...aux]
      };

    default:
      return state;
  }
}
